// DoNotSell.js — CCPA/CPRA "Do Not Sell or Share My Personal Information" page.

import React, { useEffect, useState } from 'react';
import './Styling/LegalPage.css';

export default function DoNotSell() {
  useEffect(() => {
    document.title = "Do Not Sell or Share — MyEmployeeManual.com";
  }, []);

  const [gpc, setGpc] = useState(false);
  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.globalPrivacyControl) {
      setGpc(true);
      // Persist that GPC opt-out was detected so the rest of the app can honor it.
      try { localStorage.setItem('mem_gpc_optout', '1'); } catch {}
    }
  }, []);

  return (
    <div className="legalPage">
      <div className="legalPage__container">
        <h1>Do Not Sell or Share My Personal Information</h1>
        <p>
          Under the California Consumer Privacy Act (CCPA), as amended by the California Privacy Rights Act (CPRA), and other U.S. state privacy laws, you have the right to direct us not to sell or share your Personal Information.
        </p>

        <h2>We do not currently sell or share Personal Information.</h2>
        <p>
          MyEmployeeManual.com <strong>does not sell</strong> Personal Information for monetary consideration, and we <strong>do not share</strong> Personal Information for cross-context behavioral advertising, as those terms are defined in the CCPA/CPRA. If that changes, we will update our <a href="/privacyPolicy">Privacy Policy</a> and provide the disclosures and opt-out mechanisms required by law before any sale or sharing begins.
        </p>

        <h2>Global Privacy Control (GPC)</h2>
        {gpc ? (
          <p style={{ color: '#5FC5FA' }}>
            <strong>We detected a Global Privacy Control signal from your browser.</strong> We treat this as a valid opt-out of any sale or sharing for this browser.
          </p>
        ) : (
          <p>
            We honor the Global Privacy Control browser signal as a valid opt-out request under California law. If your browser sends a GPC signal, we treat it as a request to opt out of sale and sharing for that browser.
          </p>
        )}

        <h2>Submit a manual request</h2>
        <p>If you prefer to submit a written request, contact us:</p>
        <ul>
          <li><strong>Email:</strong> <a href="mailto:privacy@myemployeemanual.com">privacy@myemployeemanual.com</a></li>
          <li><strong>Web form:</strong> <a href="/contact">Contact Form</a></li>
          <li><strong>Mail:</strong> MyEmployeeManual.com, Attn: Privacy, 3217 Carson Street, Suite 915, Lakewood, CA 90712</li>
        </ul>
        <p>We will respond within the timeframes required by law (generally 15 business days for opt-out requests).</p>
      </div>
    </div>
  );
}
